module.exports = __webpack_public_path__ + "img/MapTitle.07958c04.png";